import { Amplify } from 'aws-amplify';

// Pool configurations
const personalPoolConfig = {
  userPoolId: 'eu-west-2_ZpYYsH8It',
  userPoolClientId: '1l19sj9gh4dtck8tni3gjcbmf9',
};

const businessPoolConfig = {
  userPoolId: 'eu-west-2_nvsD7s0AR',
  userPoolClientId: '2gh2h37umegda5tpddvgfhg71b',
};

// API configuration (shared across both pools)
const apiConfig = {
  REST: {
    'smart-storage-api': {
      endpoint: 'https://z9hnkb6rm3.execute-api.eu-west-2.amazonaws.com/prod',
      region: 'eu-west-2',
    }
  }
};

/**
 * Configure Amplify for a specific user type
 * @param userType - 'personal' or 'business'
 */
export const configureAmplifyForUserType = (userType: 'personal' | 'business') => {
  const poolConfig = userType === 'business' ? businessPoolConfig : personalPoolConfig;
  
  Amplify.configure({
    Auth: {
      Cognito: {
        ...poolConfig,
        signUpVerificationMethod: 'code' as const,
        loginWith: {
          email: true,
        },
      }
    },
    API: apiConfig
  });
  
  // Store selection in localStorage
  localStorage.setItem('userType', userType);
  localStorage.setItem('userPoolId', poolConfig.userPoolId);
  
  console.log(`Amplify configured for ${userType} user pool: ${poolConfig.userPoolId}`);
};

/**
 * Initialize Amplify on app load
 * Restores user type from localStorage or defaults to personal pool
 */
export const initializeAmplify = () => {
  const storedUserType = localStorage.getItem('userType') as 'personal' | 'business' | null;
  
  if (storedUserType && (storedUserType === 'personal' || storedUserType === 'business')) {
    configureAmplifyForUserType(storedUserType);
  } else {
    // Default to personal pool
    configureAmplifyForUserType('personal');
  }
};

/**
 * Get the current user type from localStorage
 */
export const getCurrentUserType = (): 'personal' | 'business' => {
  const storedUserType = localStorage.getItem('userType');
  return (storedUserType === 'business' ? 'business' : 'personal');
};

/**
 * Clear user type selection (called on logout)
 */
export const clearUserTypeSelection = () => {
  localStorage.removeItem('userType');
  localStorage.removeItem('userPoolId');
};

// Initialize Amplify immediately with stored or default configuration
initializeAmplify();

// Export pool configurations for testing
export { personalPoolConfig, businessPoolConfig };

